import { render, staticRenderFns } from "./DistressalertssitrepModals.vue?vue&type=template&id=02394a37"
import script from "./DistressalertssitrepModals.vue?vue&type=script&lang=js"
export * from "./DistressalertssitrepModals.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports